'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lozad = require('../lozad');

var _lozad2 = _interopRequireDefault(_lozad);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var browser = (0, _util.getBrowser)();

var IE9Wrapper = function IE9Wrapper(props) {
  var isIE9 = browser.name === 'MSIE' && browser.version === '9';

  if (isIE9) {
    return _react2.default.createElement(
      'video',
      { style: { display: 'none' } },
      props.children
    );
  }

  return props.children;
};

var Picture = function (_Component) {
  _inherits(Picture, _Component);

  function Picture(props) {
    _classCallCheck(this, Picture);

    var _this = _possibleConstructorReturn(this, (Picture.__proto__ || Object.getPrototypeOf(Picture)).call(this, props));

    _this.pictureRef = _react2.default.createRef();
    return _this;
  }

  _createClass(Picture, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
        this.setupLazyLoad();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setupLazyLoad();
    }
  }, {
    key: 'setupLazyLoad',
    value: function setupLazyLoad() {
      if (!this.pictureRef.current) {
        return;
      }

      if (this.props.lazy) {
        var el = this.pictureRef.current;
        var lozadInstance = (0, _lozad2.default)(el, {
          threshold: 0.01,
          rootMargin: '40px 0px 0px 0px',
          loaded: function loaded() {
            if (window.picturefill && typeof window.picturefill === 'function') {
              window.picturefill();
            }
          }
        });

        lozadInstance.observe();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          breakpoints = _props.breakpoints,
          alt = _props.alt,
          lazy = _props.lazy,
          rest = _objectWithoutProperties(_props, ['config', 'breakpoints', 'alt', 'lazy']);

      if (!config) {
        return null;
      }

      var defaultBp = void 0;
      return _react2.default.createElement(
        'picture',
        _extends({}, rest, {
          'data-alt': alt,
          ref: this.pictureRef,
          key: JSON.stringify(this.props)
        }),
        _react2.default.createElement(
          IE9Wrapper,
          null,
          Object.keys(breakpoints).map(function (b) {
            var bpConfig = config.breakpoints[b];
            var bp = breakpoints[b];

            if (!bpConfig) {
              // eslint-disable-next-line no-console
              console.warn('pixboost-react: Can\'t find breakpoint config for ' + b);
              return;
            }
            if (!bpConfig.media) {
              defaultBp = bp;
              return;
            }

            return _react2.default.createElement('source', {
              key: b,
              media: bpConfig.media,
              srcSet: Picture.bpSrc(config, bp)
            });
          })
        ),
        defaultBp && !lazy && _react2.default.createElement('img', { src: Picture.bpSrc(config, defaultBp), alt: alt }),
        defaultBp && lazy && _react2.default.createElement('source', { srcSet: Picture.bpSrc(config, defaultBp) })
      );
    }
  }], [{
    key: 'bpSrc',
    value: function bpSrc(config, bp) {
      if (bp.hide || !bp.src) {
        return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      }

      if (bp.src.indexOf('data:') === 0) {
        return bp.src;
      }
      var op = bp.op || 'optimise';

      return '' + (config.domain.includes('//') ? '' : '//') + config.domain + '/api/2/img/' + (0, _util.prepareSource)(bp.src) + '/' + op + (op.includes('?') ? '&' : '?') + 'auth=' + config.apiKey;
    }
  }]);

  return Picture;
}(_react.Component);

Picture.propTypes = {
  alt: _propTypes2.default.string,
  lazy: _propTypes2.default.bool,
  breakpoints: _propTypes2.default.object.isRequired,
  config: _propTypes2.default.object.isRequired
};

Picture.defaultProps = {
  lazy: true
};

exports.default = Picture;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pixboost-react/lib/components/Picture.js
// module id = 103
// module chunks = 0